import { render, staticRenderFns } from "./QuantityBreaksDialog.vue?vue&type=template&id=a64c300c&scoped=true&"
import script from "./QuantityBreaksDialog.vue?vue&type=script&lang=ts&"
export * from "./QuantityBreaksDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuantityBreaksDialog.vue?vue&type=style&index=0&id=a64c300c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64c300c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
